import React from 'react';
import { Route, Routes } from 'react-router-dom';

export const configAccountRoutes = ({ ConfigAccount }: { ConfigAccount: React.ComponentType }) => (
  <Routes>
    <Route path="" element={<ConfigAccount />} />
  </Routes>
);
